import { getClient } from '@cdab/scania/qpr/contexts/backend-provider'
import { Link } from 'react-router-dom'

export interface AvatarMenuProps {
  onAvatarMenuClick?: () => void
  userName: string
  name: string
}

export function AvatarMenu(props: AvatarMenuProps) {
  const { name, userName, onAvatarMenuClick } = props
  const onLogoutClick = () => {
    const client = getClient()
    client.Logout({ redirectUri: `${window.location.origin}/loggedout` })
  }

  return (
    <li className='tds-nav__item sdds-nav__avatar'>
      <button className='tds-nav__avatar-btn' onClick={onAvatarMenuClick}>
        <img
          className='tds-nav__avatar-img'
          src='https://www.svgrepo.com/show/170303/avatar.svg'
          alt='profile'
        />
        <div className='tds-nav__avatar-info sdds-nav__avatar-info--mobile'>
          <p className='tds-nav__avatar-title'>{name}</p>
          <p className='tds-nav__avatar-subtitle'>{userName}</p>
        </div>
      </button>
      <ul className='tds-nav__avatar-menu'>
        <li className='tds-nav__avatar-item sdds-nav__avatar-item--large'>
          <div className='tds-nav__avatar-info'>
            <p className='tds-nav__avatar-title'>{name}</p>
            <p className='tds-nav__avatar-subtitle'>{userName}</p>
          </div>
        </li>
        <li className='tds-nav__avatar-item'>
          <Link to='profile' className='tds-nav__avatar-item-core'>
            My Profile
          </Link>
        </li>
        <li className='tds-nav__avatar-item'>
          <button onClick={onLogoutClick} className='tds-nav__avatar-item-core'>
            Logout
          </button>
        </li>
      </ul>
    </li>
  )
}
